/**
 * Created by karora on 12/03/17.
 */
import { Pipe, PipeTransform } from '@angular/core';
/*
 * Format a boolean true/false to Y/N
 */
@Pipe({
    name: 'boolean',
    standalone: false
})
export class BooleanPipe implements PipeTransform {
  transform(value: boolean): string {
    return (value ? "Y" : "N");
  }
}
